import { createTypes, createAction } from 'lib/action'

// *load ข้อมูลต้นแหล่ง
const SURVEY_SOURCING_LOAD_SOURCE = createTypes(
  'surveySourcingLoadSource',
  'load'
)

// *load table log
const SURVEY_SOURCING_LOAD_TABLE_LOG = createTypes(
  'surveySourcingLoadTableLog',
  'load'
)

// *load detail สำรวจต้นแหล่ง
const SURVEY_SOURCING_DETAIL = createTypes('surveySourcingDetail', 'load')

// *delete ข้อมูล
const SURVEY_SOURCING_DELETE = createTypes('surveySourcingDelete', 'delete')

// *add new location
const SURVEY_SOURCING_ADD_NEW_LOCATION = createTypes(
  'surveySourcingAddNewLocation',
  'add'
)

// *edit location
const SURVEY_SOURCING_EDIT_LOCATION = createTypes(
  'surveySourcingEditLocation',
  'edit'
)

// *remove lists
const REMOVE_LISTS = `REMOVE_LISTS`

// *remove lists
function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

// *load ข้อมูลต้นแหล่ง
const surveySourcingLoadSource = {
  request: (data) =>
    createAction(SURVEY_SOURCING_LOAD_SOURCE.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(SURVEY_SOURCING_LOAD_SOURCE.SUCCESS, { lists }),
  failure: () => createAction(SURVEY_SOURCING_LOAD_SOURCE.FAITLURE),
}

// *load ข้อมูล table log
const surveySourcingLoadTableLog = {
  request: (data) =>
    createAction(SURVEY_SOURCING_LOAD_TABLE_LOG.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(SURVEY_SOURCING_LOAD_TABLE_LOG.SUCCESS, { lists }),
  failure: () => createAction(SURVEY_SOURCING_LOAD_TABLE_LOG.FAITLURE),
}

// *load detail สำรวจต้นแหล่ง
const surveySourcingDetail = {
  request: (data) =>
    createAction(SURVEY_SOURCING_DETAIL.REQUEST, {
      data,
    }),
  success: (lists) => createAction(SURVEY_SOURCING_DETAIL.SUCCESS, { lists }),
  failure: () => createAction(SURVEY_SOURCING_DETAIL.FAITLURE),
}

// *delete ข้อมูล
const surveySourcingDelete = {
  request: (data) =>
    createAction(SURVEY_SOURCING_DELETE.REQUEST, {
      data,
    }),
  success: (lists) => createAction(SURVEY_SOURCING_DELETE.SUCCESS, { lists }),
  failure: () => createAction(SURVEY_SOURCING_DELETE.FAITLURE),
}

// *add new location
const surveySourcingAddNewLocation = {
  request: (data) =>
    createAction(SURVEY_SOURCING_ADD_NEW_LOCATION.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(SURVEY_SOURCING_ADD_NEW_LOCATION.SUCCESS, { lists }),
  failure: () => createAction(SURVEY_SOURCING_ADD_NEW_LOCATION.FAITLURE),
}

// *edit location
const surveySourcingEditLocation = {
  request: (data) =>
    createAction(SURVEY_SOURCING_EDIT_LOCATION.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(SURVEY_SOURCING_EDIT_LOCATION.SUCCESS, { lists }),
  failure: () => createAction(SURVEY_SOURCING_EDIT_LOCATION.FAITLURE),
}

export {
  SURVEY_SOURCING_LOAD_SOURCE,
  surveySourcingLoadSource,
  SURVEY_SOURCING_LOAD_TABLE_LOG,
  surveySourcingLoadTableLog,
  SURVEY_SOURCING_DETAIL,
  surveySourcingDetail,
  SURVEY_SOURCING_DELETE,
  surveySourcingDelete,
  SURVEY_SOURCING_ADD_NEW_LOCATION,
  surveySourcingAddNewLocation,
  SURVEY_SOURCING_EDIT_LOCATION,
  surveySourcingEditLocation,
  REMOVE_LISTS,
  removeLists,
}
